import update from 'immutability-helper';
import * as actionTypes from '../constants/actionTypes';
var initalState = {
    areVisible: false,
    areLoaded: false,
};
export default function hotspots(state, action) {
    if (state === void 0) { state = initalState; }
    switch (action.type) {
        case actionTypes.SHOW_HOTSPOTS:
            return update(state, { areVisible: { $set: true } });
        case actionTypes.HIDE_HOTSPOTS:
            return update(state, { areVisible: { $set: false } });
        case actionTypes.LOAD_HOTSPOTS_DONE:
            return update(state, { areLoaded: { $set: true } });
        case actionTypes.SET_PROJECT:
            return update(state, { areLoaded: { $set: true } });
        default:
            return state;
    }
}
